module.exports = __webpack_public_path__ + "img/image00013-14-min.6c77d007.jpg";